import Model from './model';
import Utils from './utils';
import deepEqual from 'deep-equal';
import extend from 'extend';

export default class Facade {

  constructor(DataModel) {
    this.listeners = [];

    this.model = new DataModel();

    if (!this.model instanceof Model) {
      throw new Error('Not inherited from Cliser.Model');
    }

    this.name = DataModel.name;

    let properties = this.model.properties();
    let propertyKeys = Object.getOwnPropertyNames(properties);
    Object.assign(this.model, properties);

    this.model.init();

    this.publicMethods = {
      getState: () => {
        return new Promise((resolve, reject) => {
          Promise.all(propertyKeys.map((key) => Utils.createPromise(this.model[key])))
            .then((values) => {
              let state = {};
              values.forEach((value, idx) => state[propertyKeys[idx]] = value);
              resolve(state);
            })
            .catch(reject);
        });
      }
    };

    const getSyncState = () => {
      let state = {};
      propertyKeys.forEach((key) => {
        let value = this.model[key];
        if (typeof value === 'function') {
          state[key] = value();
        } else if (!(value instanceof Promise)) {
          state[key] = value;
        }
      });
      return extend(true, {}, state);
    }

    this.model._observer = {
      onChange: () => {
        this.publicMethods.getState().then((state) => {
          this.listeners.forEach((callback) => callback(state));
        });
      }
    };

    Object.getOwnPropertyNames(DataModel).forEach((name) => {
      switch (name) {
        case 'length':
        case 'prototype':
        case 'name':
          return;
        default:
          if (typeof DataModel[name] === 'function') {
            this.model[name] = DataModel[name].bind(this.model);

            this.publicMethods[name] = (...args) => {
              let oldState = getSyncState();
              const emitChangedState = () => {
                const newState = getSyncState();
                if (!deepEqual(oldState, newState)) {
                  this.listeners.forEach((callback) => callback(newState));
                }
                return newState;
              }

              let result = DataModel[name].call(this.model, ...args);
              oldState = emitChangedState();

              if (result instanceof Promise) {
                result.then((...args) => {
                  emitChangedState();
                  return Promise.all(args);
                });
              }
              return Utils.createPromise(result);
            }
          }
      }
    })
  }

  addListener(callback) {
    if (typeof callback === 'object' && typeof callback.setState === 'function') {
      callback = callback.setState.bind(callback);
    }
    this.listeners.push(callback);
  }

  removeListener(callback) {
    let idx = this.listeners.findIndex((x) => x === callback);
    if (idx >= 0) {
      this.listeners.splice(idx, 1);
    }
  }

  uninit() {
    this.model.uninit();
  }
}



// WEBPACK FOOTER //
// ./modules/cliser/src/facade.js